import { Component, Input, OnInit } from '@angular/core';
import { EntityType, EntityTypeDynamic } from 'app/assessment/models';
import { AppScopes } from 'app/core/authentication/models/scopes.enum';
import { AuthService } from 'app/core/authentication/services';
import { UserInterface } from 'app/core/user/models';
import { TaskDialogDataInterface } from 'app/task/models/task-dialog-data.model';
import { TaskInterface } from 'app/task/models/task.model';
import { TaskDialogService } from 'app/task/services/task-dialog.service';
import { of } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';

@Component({
  selector: 'cz-task-card',
  templateUrl: './task-card.component.html',
  styleUrls: ['./task-card.component.scss'],
})
export class TaskCardComponent implements OnInit {
  @Input() public task: TaskInterface;

  public isAdmin: boolean;
  public isAssignedTo: boolean;
  public isSubject: boolean;

  private loggedInUser: UserInterface;
  constructor(private readonly _authService: AuthService,
              private readonly _taskDialogService: TaskDialogService) {}

  public ngOnInit(): void {
    // Determine if the user can edit the task.
    this._authService.isLoggedInUserAuthorized([AppScopes.CASE_MANAGEMENT_MASTER]).pipe(
      take(1),
      switchMap((isTaskAdmin: boolean) => {
        return of(isTaskAdmin);
      }),
      switchMap((isTaskAdmin: boolean) => {
        return this._authService.getAuthenticatedUser().pipe(
          take(1),
          map((user: UserInterface) => ({ isTaskAdmin, user })),
        );
      }),
      ).subscribe((userAuthMap: { isTaskAdmin: boolean, user: UserInterface }) => {
        this.isAssignedTo = userAuthMap.user.id === this.task.assignedTo.id;
        this.isSubject = userAuthMap.user.id === this.task.subject.id;
        this.isAdmin = userAuthMap.isTaskAdmin;
        if(!this.isAdmin) {
          this.isAdmin = userAuthMap.user.id === this.task.createdBy.id;
        }
        this.loggedInUser = userAuthMap.user;
      });
  }

  public openTaskDialog(showCommentsInDialog?: boolean): void {
    const dialogData: TaskDialogDataInterface = {
      isTaskAdmin: this.isAdmin,
      loggedInUser: this.loggedInUser,
    };
    this._taskDialogService.openTaskDialog(this.task, dialogData, showCommentsInDialog);
  }

  public getTypeString(type: string): string {
    switch (type.toLowerCase()) {
      case EntityType.SURVEY:
        return EntityTypeDynamic.SURVEY;
      case EntityType.EVALUATION:
        return EntityTypeDynamic.EVALUATION;
      default: return type;
    }
  }
}
